import { useNavigation, useRoute } from "@react-navigation/native"

interface UseComposeMessageCtrlProps {
  // Modal context props
  onBack?: () => void
  onNext?: () => void
  onClose?: () => void
  updateStackData?: (data: Record<string, any>) => void
  completeStep?: (stepData?: Record<string, any>) => void
}

const useComposeMessageCtrl = (props?: UseComposeMessageCtrlProps) => {
    const navigation = useNavigation()
    
    // Try to get route params, but handle case when not in navigation context
    let routeParams: { isEdit?: boolean; scheduledMessageId?: string } = {};
    try {
        const route = useRoute();
        routeParams = route.params as { isEdit?: boolean; scheduledMessageId?: string } || {};
    } catch (error) {
        // Not in navigation context, use empty params
        routeParams = {};
    }
    
    // Check if we're in modal context - if props are provided, we're in modal
    const isModalContext = props?.onNext && props?.onBack
    
    const goBack = () => {
        if (isModalContext && props?.onBack) {
            props.onBack()
        } else {
            navigation.goBack()
        }
    }

    const completeCompose = (messageData?: Record<string, any>) => {
        if (isModalContext && props?.completeStep) {
            // In modal context, complete the step
            props.completeStep(messageData)
        } else {
            // In navigation context, go back
            navigation.goBack()
        }
    }

    const getRouteParams = () => {
        return routeParams;
    }

    return {
        goBack,
        completeCompose,
        getRouteParams,
        isModalContext,
    }
}

export default useComposeMessageCtrl
